export default __webpack_public_path__ + "06ca5df67e78467a39f9ce7a5dff4fe5.webp";